import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section-card" }
const _hoisted_2 = { class: "section-header" }
const _hoisted_3 = { class: "section-title" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "card-desc" }

import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'InquiryDetailDescriptionSection',
  props: {
    title: { default: "" },
    time: { default: "" },
    inquiryNo: { default: "" },
    description: { default: "" },
    icon: { default: "mdi-wrench" },
    iconTone: { default: "card-icon--peach" },
    priority: { default: "" }
  },
  setup(__props: any) {

const props = __props;

const isUrgentPriority = computed(
  () => props.priority.trim().toLowerCase() === "urgent",
);

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(__props.inquiryNo), 1)
    ]),
    _createVNode(_component_v_divider),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, _toDisplayString(__props.description), 1)
      ])
    ])
  ]))
}
}

})